<template>
  <el-switch
    v-model="toggleValue"
    :active-text="activeText"
    :inactive-text="inactiveText"
    class="switcher-button btn-outline"
    :class="{ 'ru-locale': $i18n.locale === 'ru' }"
    @change="change"
  />
</template>

<script setup lang="ts">
interface SwitcherButtonProps {
  activeText: string;
  inactiveText: string;
  change: (value: string | number | boolean) => void;
}

defineProps<SwitcherButtonProps>();

const toggleValue = ref<boolean>(true);
</script>

<style>
.switcher-button.el-switch {
  display: flex;
  justify-content: center;
  width: 272px;
  height: 62px;

  .el-switch__core {
    display: none;
  }

  .el-switch__input {
    cursor: pointer;
    width: 100%;
    height: 100%;
  }

  .el-switch__label {
    display: block;
    margin: 0;
    color: unset;

    * {
      font-size: 16px;
    }
  }

  .el-switch__label:not(.is-active) {
    display: none;
  }
}
</style>
